// extracted by mini-css-extract-plugin
export var badge = "_vs-4";
export var selected = "_vs-1";
export var selectedOverlay = "_vs-5";
export var thumbnailButton = "_vs-0";
export var thumbnailFallback = "_vs-3";
export var thumbnailImage = "_vs-2";